import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M19 13H5a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2m0 5H5a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2m0-10H5a1 1 0 0 1 0-2h14a1 1 0 1 1 0 2"
    }
  )
);
var SvgListOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ListOutlined_default = SvgListOutlined;

export { ListOutlined_default as default };
